import { AxiosClient } from '@/app/common/services/http/axios-client.service'
import store from '@/plugins/store'
import { GetAllGeneralInsurancesCommand } from '@/app/general-insurance/commands/get-all-general-insurances.command'
import { CreateDamageReportCommand } from '@/app/general-insurance/commands/create-damage-report.command'
import { GeneralInsurancePolicyDownloadDocumentCommand } from "@/app/general-insurance/commands/general-insurance-policy-download-document.command";

const httpClient = new AxiosClient()

export const getAllGeneralInsurancesCommand = new GetAllGeneralInsurancesCommand(httpClient, store)
export const createDamageReportCommand = new CreateDamageReportCommand(httpClient, store)

export const generalInsurancePolicyDownloadDocumentCommand = new GeneralInsurancePolicyDownloadDocumentCommand(httpClient, store);

